const homepage = () => {
    if ($(".homepage").length) {
        // $(".banner-top-homepage video").on("play", function () {
        //     const $textAnimation = $(".text-slide-up");
        //     const textSlideUp = $textAnimation.data("anime");
        //     textSlideUp.restart();
        //     window.animeX = anime
        // }).on("pause", function(){
        //     this.currentTime = 0;
        //     const $textAnimation = $(".text-slide-up");
        //     const textSlideUp = $textAnimation.data("anime");
        //     textSlideUp.pause();
        //     textSlideUp.restart()
        // })
        // .on("timeupdate", function(){
        //     console.log(this.currentTime)
        // })
        $('.portfolio-slide').slick({
            dots: true,
            infinite: true,
            speed: 500,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 3000,
            centerMode: true,
            arrows: false
        });

        $('.logo-slide').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            fade: false,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 3000,
            rows: 3,
            slidesPerRow: 6,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    rows: 4,
                    slidesPerRow: 4,
                  }
                }
              ]
        });
    }
}

module.exports = homepage
